import { render, staticRenderFns } from "./Error404.vue?vue&type=template&id=b4adbce6&scoped=true&"
import script from "./Error404.vue?vue&type=script&lang=js&"
export * from "./Error404.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/mobile/_error404.scss?vue&type=style&index=0&id=b4adbce6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4adbce6",
  null
  
)

export default component.exports